module.exports = __webpack_public_path__ + "static/img/top_lan.9416d57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/top_lan.png
// module id = E4GJ
// module chunks = 3